import { ConfirmVerifyCodeModal as Component } from "../../../components/organisms/modal/ConfirmVerifyCodeModal";

type Props = {
  value: string;
  title: string;
  isOpen: boolean;
  isLoading: boolean;
  onPublishClick: () => void;
  onCancelClick: () => void;
};

export const ConfirmVerifyCodeModal = (props: Props) => {
  return <Component {...props} />;
};
